import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { TextField } from '@mui/material';
import { formatDate } from '../modules/ConvertDate';

export default function Datepicker(props) {
    const [cleared, setCleared] = useState(false);
    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);

            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [cleared]);

    const getLocalStartOfDayUTC = (dateStr) => {
        if (!dateStr) return '';
        const [year, month, day] = dateStr.split('-').map(Number);
        const date = new Date(year, month - 1, day, 0, 0, 0, 0);
        return date.toISOString();
    };

    const getLocalEndOfDayUTC = (dateStr) => {
        if (!dateStr) return '';
        const [year, month, day] = dateStr.split('-').map(Number);
        const date = new Date(year, month - 1, day, 23, 59, 59, 999);
        return date.toISOString();
    };

    return (
        <Box className='flex gap-2 items-center'>
            <TextField type='date' value={props?.filterdata?.from?.split('T')[0]} fullWidth size='small'
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                    const dateStr = e.target.value; // "YYYY-MM-DD"
                    props?.setFilterdata((prevState) => ({
                        ...prevState,
                        from: dateStr ? getLocalStartOfDayUTC(dateStr) : dateStr,
                    }));
                }}
                InputProps={{
                    inputProps: {
                        format: 'dd-mm-yyyy',
                        max: props?.filterdata?.to?.split('T')[0],
                    },
                }}
            />
            -
            <TextField type='date' value={props?.filterdata?.to?.split('T')[0]} fullWidth size='small'
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                    const dateStr = e.target.value; // "YYYY-MM-DD"
                    props?.setFilterdata((prevState) => ({
                        ...prevState,
                        to: dateStr ? getLocalEndOfDayUTC(dateStr) : dateStr,
                    }));
                }}
                InputProps={{
                    inputProps: {
                        format: 'dd-mm-yyyy',
                        min: props?.filterdata?.from?.split('T')[0],
                    },
                }}
            />
        </Box>
    );
}
